"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AUTOCOMPLETE_ICON_CLOSE = exports.AUTOCOMPLETE_ICON_SHOW_MENU = exports.AUTOCOMPLETE_ICON_HIDE_MENU = exports.MENU_MARGIN_PX_HEIGHT = exports.DIVIDER_PX_HEIGHT = exports.GROUP_PX_HEIGHT = exports.OPTION_PX_HEIGHT = exports.menuPositions = exports.sizes = void 0;
var sizes = {
  S: 's',
  M: 'm',
  L: 'l',
  XL: 'xl',
  AUTO: 'auto',
  s: 's',
  m: 'm',
  l: 'l',
  xl: 'xl',
  auto: 'auto'
};
exports.sizes = sizes;
var menuPositions = {
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right',
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
  TOP: 'top',
  BOTTOM: 'bottom',
  AUTO: 'auto',
  AUTO_TOP: 'auto-top',
  AUTO_BOTTOM: 'auto-bottom'
};
exports.menuPositions = menuPositions;
var OPTION_PX_HEIGHT = 30;
exports.OPTION_PX_HEIGHT = OPTION_PX_HEIGHT;
var GROUP_PX_HEIGHT = 34; // top & bottom padding + bottom-border with margin

exports.GROUP_PX_HEIGHT = GROUP_PX_HEIGHT;
var DIVIDER_PX_HEIGHT = 12;
exports.DIVIDER_PX_HEIGHT = DIVIDER_PX_HEIGHT;
var MENU_MARGIN_PX_HEIGHT = 2; // the space between menu and the button

exports.MENU_MARGIN_PX_HEIGHT = MENU_MARGIN_PX_HEIGHT;
var AUTOCOMPLETE_ICON_HIDE_MENU = 'sbi-chevron-up';
exports.AUTOCOMPLETE_ICON_HIDE_MENU = AUTOCOMPLETE_ICON_HIDE_MENU;
var AUTOCOMPLETE_ICON_SHOW_MENU = 'sbi-chevron-down';
exports.AUTOCOMPLETE_ICON_SHOW_MENU = AUTOCOMPLETE_ICON_SHOW_MENU;
var AUTOCOMPLETE_ICON_CLOSE = 'sbi-close';
exports.AUTOCOMPLETE_ICON_CLOSE = AUTOCOMPLETE_ICON_CLOSE;
//# sourceMappingURL=constants.js.map